var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "-0.72 -5.22 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.28 42.029v-10.92c0-.652 0-.978-.098-1.265a1.817 1.817 0 00-.416-.68c-.211-.217-.5-.363-1.078-.654L38.28 20.23m-28.8 3.634v24.728c0 1.351 0 2.027.209 2.619.185.523.486.996.88 1.383.445.438 1.054.72 2.271 1.282l23.04 10.657c.883.409 1.324.613 1.784.694.408.07.824.07 1.232 0 .46-.081.901-.285 1.784-.694l23.04-10.657c1.217-.562 1.826-.844 2.272-1.282.394-.387.694-.86.88-1.383.208-.592.208-1.268.208-2.619V23.864M2.28 20.23L36.992 2.716c.472-.239.708-.358.956-.405.22-.041.445-.041.664 0 .248.047.484.166.956.405L74.28 20.23 39.568 37.746c-.472.238-.708.357-.956.404a1.78 1.78 0 01-.664 0c-.248-.047-.484-.166-.956-.404L2.28 20.23z",
    stroke: "currentColor",
    strokeWidth: 4.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCourse;